import './hero.scss';
